/** * 左边菜单 */
<template>
  <div class="left-nav">
    <div class="logobox">
      职业技能认定
    </div>
    <div class="left-box">
      <div class="left-menu">
        <div
          v-for="(item, index) in allmenu"
          :key="index"
          :class="['menu-parent', activeMenu === item.path ? 'is-active' : '']"
        >
          <img :src="item.meta.icon" alt="" />
          {{ item.meta.title }}
          <div
            :class="[
              'menu-item',
              $route.path === `${item.path}/${menu.path}` ? 'active-menu' : ''
            ]"
            v-for="(menu, key) in item.children"
            :key="key"
            @click.stop="routerChange(item, menu)"
          >
            {{ menu.meta.title }}
          </div>
        </div>
      </div>
      <div class="left-footer">
        <!-- <div class="back" @click="back">返回引导页</div> -->
        <img src="@/assets/img/menu/nav-footer.png" alt="" />
        <navcon></navcon>
      </div>
    </div>
  </div>
</template>
<script>
import { menu } from "../../api/userMG";
import { menuConfig } from "@/router/menu.js";
import navcon from "./navcon.vue";
export default {
  name: "LeftNav",
  components: {
    navcon
  },
  data() {
    return {
      collapsed: false,
      allmenu: []
    };
  },
  computed: {
    activeMenu() {
      return "/" + this.$route.path.split("/")[1];
    }
  },
  // watch: {
  //   $route(to, from) {
  //     if (to.path == "/student/manage") {
  //       this.allmenu = publicConfig;
  //     } else {
  //       this.allmenu = menuConfig;
  //     }
  //     // this.allmenu = menuConfig;
  //   }, // 设置为深度监听
  //   deep: true
  // },
  methods: {
    // back() {
    //   this.$router.push("/menu");
    // },
    routerChange(menu, children) {
      this.$router.push(menu.path + "/" + children.path);
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.allmenu = menuConfig;
    // if (this.$route.path == "/student/manage") {
    //   this.allmenu = publicConfig;
    // } else {
    //   this.allmenu = menuConfig;
    // }
    // 监听
    this.$root.Bus.$on("toggle", value => {
      this.collapsed = !value;
    });
  }
};
</script>
<style lang="less">
.left-nav {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .logobox {
    height: 64px;
    line-height: 64px;
    text-align: center;
    background-color: #fcfdff;
    color: #1c68ff;
    font-size: 16px;
    font-weight: 600;
  }
  .left-box {
    flex: 1;
    margin-top: 12px;
    overflow-y: auto;
    padding: 24px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .left-menu {
    .menu-parent {
      color: #4e5969;
      font-size: 14px;
      line-height: 40px;
      margin-bottom: 24px;
      cursor: pointer;
      img {
        width: 18px;
        margin-right: 14px;
        vertical-align: middle;
        opacity: 0.3;
      }
      .menu-item {
        color: #86909c;
        font-size: 12px;
        padding-left: 34px;
        border-radius: 8px;
      }

      .active-menu {
        color: #fff;
        background-color: #1c68ff;
      }
    }
    .is-active {
      color: #1c68ff;
      img {
        opacity: 1;
      }
    }
  }
  .left-footer {
    img {
      width: 100%;
    }
    .back {
      text-align: center;
      line-height: 32px;
      border-radius: 8px;
      border: 1px solid #1c68ff;
      margin-bottom: 8px;
      color: #1c68ff;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        background-color: #1c68ff;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/leftnav.vue